<template>
  <div class="animation-panel">
    <div class="animation-panel__header">
      <span class="font-14 font-bold">
        {{ $i18nPresenter.t('Animation') }}
      </span>
      <aha-icon
        class="text-base-70 hover:text-primary-90 cursor-pointer"
        name="close"
        width="16"
        height="16"
        @click.stop="closePanelAnimation"
        viewBox="0 0 24 24"
      />
    </div>
    <div class="animation-panel__content-wrapper">
      <div
        class="animation-item cursor-pointer "
        @click.stop="onChooseAnimation(null )"
        :class="!animation || animation.length === 0 ? 'active-animation-item' : ''"
      >
        <div class=" flex items-center info-animation">
          <img :src="require('@/assets/animations/editor/ignore.svg')" class="mr-3" alt="Success">
          {{ $i18nPresenter.t('No animation') }}
        </div>
      </div>
      <div>
        <div class="font-14 font-bold mt-6 mb-3">
          Appear
        </div>
        <div
          v-for="(animate, index) in animations.appear"
          :key="index"
          class="animation-item cursor-pointer "
          :class="activeAnimationItemClass(animate)"
          v-hover-intent="{
            onEnter: () => onHoverAnimation(animate, 'over'),
            onExit: () => onHoverAnimation(animate, 'out')
          }"
        >
          <div
            class=" flex items-center info-animation"
            @click.stop="onChooseAnimation(animate)"
          >
            <img :src="require('@/assets/animations/editor/'+ animate.icon+ '.svg')" class="mr-3" alt="Success">
            <span class="text-animate"> {{ animate.name }}</span>
          </div>
          <div
            class="wrapper-direction"
            v-if="isShowDirection(animate)"
          >
            <div class="mb-2 ">
              {{ $i18nPresenter.t('Direction') }}
            </div>

            <div
              class="direction-tool-box"
            >
              <div
                v-for="(direction, index) in animate.direction"
                :key="index"
                class="direction-item"
                :class="activeDirection(direction , animate.value) ? 'active-direction-item' : ''"
                @click.stop="changeDirection(direction)"
                v-hover-intent="{
                  onEnter: () => onHoverAnimation(animate, 'over',direction),
                  onExit: () => onHoverAnimation(animate, 'out',direction)
                }"
              >
                <aha-icon :name="iconsDirection[direction]" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div class="font-14 font-bold mt-6 mb-3">
          {{ $i18nPresenter.t('Others') }}
        </div>
        <div
          v-for="(animate, index) in animations.others"
          :key="index"
          class="animation-item cursor-pointer "
          :class="activeAnimationItemClass(animate)"
          @click.stop="onChooseOthersAnimation(animate)"
          v-hover-intent="{
            onEnter: () => onHoverOtherAnimation(animate, 'over'),
            onExit: () => onHoverOtherAnimation(animate, 'out')
          }"
        >
          <div class=" flex items-center info-animation">
            <img :src="require('@/assets/animations/editor/'+ animate.icon+ '.svg')" class="mr-3" alt="Success">
            <span class="text-animate"> {{ animate.name }}</span>
          </div>
          <div class="wrapper-direction" v-if=" animation && animation.includes(animate.value) && !isRichText">
            <div class="text-direction flex justify-between items-center">
              {{ $i18nPresenter.t('Loop') }}
              <toggle-button
                :sync="true"
                :width="35"
                :height="20"
                :color="{
                  checked: '#6A1EBB',
                  unchecked: '#D3D7E1'
                }"
                :value="loops[animate.value]"
                @change="onCheckInfinity(animate)"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import { mapState } from 'vuex'
import EventBus from '@/eventBus'
import utils from '@/util'
import eventCategories from '@/constant/eventCategories'

export default {
  components: {},

  data() {
    return {
      duration: 1,
      // state hover animation
      hoverAnimation: null,
      animation: null,
      isInfinity: false,
      isShowAnimationEditor: false,
      iconsDirection: {
        '': 'default_direction',
        Down: 'bottom_direction',
        Left: 'right_direction',
        Right: 'left_direction',
        Up: 'up_direction',
      },

      loops: {
        pulse: false,
        flash: false,
        shakeX: false,
      },
      oldAnimationConfig: {
        loop: false,
        duration: 0,
        animation: '',
      },
      animations:
        {
          appear: [
            {
              name: this.$i18nPresenter.t('Fade In'),
              value: 'fadeIn',
              direction: ['', 'Down', 'Up', 'Left', 'Right'],
              icon: 'fadeIn',
            },
            {
              name: this.$i18nPresenter.t('Slide In'),
              value: 'slideIn',
              direction: ['Down', 'Up', 'Left', 'Right'],
              icon: 'slideIn',
            },
            {
              name: this.$i18nPresenter.t('Zoom In'),
              value: 'zoomIn',
              direction: [''],
              icon: 'zoomIn',
            },
            {
              name: this.$i18nPresenter.t('Bounce'),
              value: 'bounceIn',
              direction: ['', 'Down', 'Up', 'Left', 'Right'],
              icon: 'bounce',
            },
          ],
          others: [
            { name: this.$i18nPresenter.t('Pulse'), icon: 'pulse', value: 'pulse' },
            { name: this.$i18nPresenter.t('Flash'), icon: 'flash', value: 'flash' },
            { name: this.$i18nPresenter.t('Shake'), icon: 'shake', value: 'shakeX' },
          ],
        },
    }
  },
  computed: {
    ...mapState({
      selectingBlocks: (state) => state.selectingBlocks,
      slideActive: (state) => state.slideActive,
      presentation: (state) => state.presentation,
    }),

    customProps() {
      return {
        slideId: this.slideActive.id,
        presentationId: this.presentation.id,
        slideType: 'Content',
      }
    },
    isRichText() {
      return this.selectingBlocks &&
          this.selectingBlocks[0] &&
          this.selectingBlocks[0].type === 'RichText'
    },
    newAnimation() {
      if (this.selectingBlocks &&
          this.selectingBlocks[0] &&
          this.selectingBlocks[0].content &&
          this.selectingBlocks[0].content.animation) {
        return this.selectingBlocks[0].content.animation
      }
      return null
    },
    blockData() {
      if (this.selectingBlocks && this.selectingBlocks.length > 0) {
        return this.selectingBlocks[0]
      }
      return null
    },

  },
  watch: {
    newAnimation() {
      this.watchChangeAnimation()
    },
  },
  mounted() {
    this.watchChangeAnimation()
  },
  methods: {
    isShowDirection(animate) {
      return this.animation
         && this.animation.includes(animate.value)
         && animate.direction
         && animate.direction.length > 1
    },
    activeAnimationItemClass(animate) {
      return this.animation && this.animation.includes(animate.value) ? 'active-animation-item' : ''
    },
    activeDirection(direction, animateValue) {
      if (direction.length === 0) {
        return this.animation && this.animation === animateValue
      }
      return this.animation && this.animation.includes(direction)
    },
    changeDirection(direction) {
      const animateVal = this.animation.replace(/(Down|Left|Right|Up)/g, '')
      const newAnimation = animateVal + direction
      this.animation = newAnimation
      this.onChangeAnimationByAttribute({ animation: newAnimation })
      utils.mixpanelTracking(eventCategories.PRESENTATION_EDITOR,
        'Animation > Select effect direction', animateVal, null, {
          ...this.customProps,
          ...{
            direction,
          },
        })
    },
    closePanelAnimation() {
      this.$store.state.isShowAnimationEditor = false
      utils.mixpanelTracking(eventCategories.PRESENTATION_EDITOR,
        'Animation > Close menu',
        'Close button', null, this.customProps)
    },
    watchChangeAnimation() {
      this.duration = this.blockData.content.duration || 0
      this.animation = this.newAnimation
      if (this.newAnimation && this.newAnimation.length > 0) {
        this.loops[this.animation] = this.blockData.content.isInfinity || false
      }
    },
    onHoverAnimation(animate, type, direction = '') {
      if (type === 'over') {
        this.hoverAnimation = animate.value + direction
        this.onChangeAnimationByAttribute({ animation: animate.value + direction, isInfinity: false })
      } else if (type === 'out' && this.hoverAnimation === (animate.value + direction)) {
        this.onChangeAnimationByAttribute({
          animation: this.animation,
          isInfinity: this.loops[this.animation],
        })
        this.hoverAnimation = null
        if (direction && direction.length > 0) {
          utils.mixpanelTracking(eventCategories.PRESENTATION_EDITOR,
            'Animation > Hover on the effect direction', animate.value, null, {
              ...this.customProps,
              ...{
                direction,
              },
            })
        } else {
          utils.mixpanelTracking(eventCategories.PRESENTATION_EDITOR,
            'Animation > Hover on the effect', animate.value, null, this.customProps)
        }
      }
    },
    onChooseAnimation(animate) {
      if (!animate) {
        // case for click remove animation
        this.animation = ''

        this.onChangeAnimationByAttribute({ animation: null, isInfinity: false })
        utils.mixpanelTracking(eventCategories.PRESENTATION_EDITOR,
          'Animation > Remove animation', null,
          null, this.customProps)
        return
      }
      this.animation = animate.value + (animate.direction ? animate.direction[0] : '')
      this.onChangeAnimationByAttribute({ animation: this.animation, isInfinity: false })
      utils.mixpanelTracking(
        eventCategories.PRESENTATION_EDITOR,
        'Animation > Select effect', animate.value,
        null, this.customProps,
      )
    },
    onChooseOthersAnimation(animate) {
      this.animation = animate.value
      this.onChangeAnimationByAttribute({ animation: this.animation, isInfinity: this.loops[animate.value] })
      utils.mixpanelTracking(eventCategories.PRESENTATION_EDITOR,
        'Animation > Select effect', animate.value, null, this.customProps)
    },
    onHoverOtherAnimation(animate, type) {
      if (type === 'over') {
        this.hoverAnimation = animate.value
        this.onChangeAnimationByAttribute({ animation: animate.value, isInfinity: this.loops[animate.value] })
      } else if (type === 'out' && this.hoverAnimation === animate.value) {
        this.onChangeAnimationByAttribute({
          animation: this.animation,
          isInfinity: this.loops[animate.value],
        })
        this.hoverAnimation = null
        utils.mixpanelTracking(eventCategories.PRESENTATION_EDITOR,
          'Animation > Hover on the effect', animate.value, null, this.customProps)
      }
    },
    updateDuration() {
      this.onChangeAnimationByAttribute({ duration: Number(this.duration) })
    },
    onCheckInfinity(animate) {
      const newLoop = !this.loops[animate.value]
      this.loops[animate.value] = newLoop
      this.onChangeAnimationByAttribute({ animation: this.animation, isInfinity: newLoop })
    },
    onChangeAnimationByAttribute(config) {
      const newBlocks = this.selectingBlocks.map((block) => {
        const newContent = {
          ...block.content,
          ...config,

        }
        return {
          ...block,
          content: newContent,
        }
      })
      EventBus.$emit('update-line-blocks', newBlocks)
    },

  },

}
</script>
<style lang="scss" scoped>
.animation-panel {
  @apply w-full h-full rounded bg-transparent;
}
.animation-panel__header {
  @apply flex justify-between items-center pl-5 pr-5 pt-4 pb-4 mb-2;
  @apply bg-base-0 w-full fixed;
  border-bottom: 1px solid #EBEBEB;

}
.font-14{
  font-size: 14px;
}
.wrapper-grid {
  @apply grid grid-cols-3 gap-1;
  place-items: center;
}

.shape-selector-wrapper {
  width: 250px;
  height: 150px;
  overflow-y:scroll;
  @apply rounded-lg shadow-xl bg-base-0;
  border: 1px solid rgba(0, 0, 0, 0.1);
  font-size: 13px;
}

.animation-item{
  overflow: hidden;
  border: 1px solid var(--base-50, #D1D1D1);
  border-radius: 8px;
  background: var(--base-0, #FFF);

  font-size: 14px;
  margin: 12px 0px;
  transition: all 0.1s ease-in-out;
  .info-animation{
    padding : 12px 16px 12px 16px
  }
  &:hover{
    border: 1px solid var(--primary-90, #6A1EBB);
    //color: var(--primary-90, #6A1EBB);
    font-size: 14px;

  }

}
.active-animation-item {
  border: 1px solid var(--primary-90, #6A1EBB);
  font-size: 14px;
  .text-animate{
    color: var(--primary-90, #6A1EBB);
    font-weight: 700;
  }
}
.wrapper-direction{
  background: var(--secondary-10, #F0F4FA);
  padding : 16px;

}

.direction-tool-box{
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  place-items: center;
  column-gap: 8px;

  .direction-item{
    width: 100%;
    aspect-ratio: 1 / 1;
    display: grid;
    place-items: center;
    border-radius: 4px;
    border: 1px solid var(--base-50, #D1D1D1);
    background: var(--base-0, #FFF);
    svg{
      path{
        fill:#313131;
      }
    }
    &.active-direction-item{
      border: 1px solid var(--primary-90, #6A1EBB);
      color: var(--primary-90, #6A1EBB);
      svg{
        path{
          fill: var(--primary-90, #6A1EBB);
        }
      }
    }

    &:hover{
      border: 1px solid var(--primary-90, #6A1EBB);
    }
  }
}

.wrapper-check{
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.animation-panel__content-wrapper {
  @apply px-5 overflow-y-auto relative;
  top: 55px;
  height: calc(100% - 55px);
}
</style>
